var moduleMap = {
	"./test": () => {
		return __webpack_require__.e(865).then(() => (() => ((__webpack_require__(72865)))));
	},
	"./handlers": () => {
		return Promise.all([__webpack_require__.e(237), __webpack_require__.e(163), __webpack_require__.e(440)]).then(() => (() => ((__webpack_require__(38888)))));
	},
	"./mfeConfig": () => {
		return __webpack_require__.e(411).then(() => (() => ((__webpack_require__(21905)))));
	},
	"./cloudEnv": () => {
		return __webpack_require__.e(411).then(() => (() => ((__webpack_require__(37627)))));
	},
	"./apiRequestsUtils": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(206), __webpack_require__.e(556)]).then(() => (() => ((__webpack_require__(33206)))));
	},
	"./navigationUtils": () => {
		return __webpack_require__.e(138).then(() => (() => ((__webpack_require__(48138)))));
	},
	"./mountComponent": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(786), __webpack_require__.e(156), __webpack_require__.e(537), __webpack_require__.e(58), __webpack_require__.e(949), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(206), __webpack_require__.e(878), __webpack_require__.e(424), __webpack_require__.e(643), __webpack_require__.e(263), __webpack_require__.e(584), __webpack_require__.e(544)]).then(() => (() => ((__webpack_require__(32163)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(95), __webpack_require__.e(582)]).then(() => (() => ((__webpack_require__(30582)))));
	},
	"./constants": () => {
		return __webpack_require__.e(154).then(() => (() => ((__webpack_require__(41154)))));
	},
	"./queryUtils": () => {
		return Promise.all([__webpack_require__.e(417), __webpack_require__.e(934)]).then(() => (() => ((__webpack_require__(57934)))));
	},
	"./storeUtils": () => {
		return Promise.all([__webpack_require__.e(95), __webpack_require__.e(265)]).then(() => (() => ((__webpack_require__(97265)))));
	},
	"./docUtils": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(206), __webpack_require__.e(878), __webpack_require__.e(834)]).then(() => (() => ((__webpack_require__(19878)))));
	},
	"./datetimeUtils": () => {
		return Promise.all([__webpack_require__.e(180), __webpack_require__.e(465)]).then(() => (() => ((__webpack_require__(64465)))));
	},
	"./notificationUtils": () => {
		return Promise.all([__webpack_require__.e(95), __webpack_require__.e(416)]).then(() => (() => ((__webpack_require__(10416)))));
	},
	"./helperUtils": () => {
		return __webpack_require__.e(180).then(() => (() => ((__webpack_require__(63180)))));
	},
	"./RetentionForm": () => {
		return Promise.all([__webpack_require__.e(893), __webpack_require__.e(417), __webpack_require__.e(786), __webpack_require__.e(156), __webpack_require__.e(58), __webpack_require__.e(95), __webpack_require__.e(180), __webpack_require__.e(582), __webpack_require__.e(411), __webpack_require__.e(206), __webpack_require__.e(878), __webpack_require__.e(424), __webpack_require__.e(643), __webpack_require__.e(263)]).then(() => (() => ((__webpack_require__(16263)))));
	},
	"./ltrUtils": () => {
		return Promise.all([__webpack_require__.e(424), __webpack_require__.e(47)]).then(() => (() => ((__webpack_require__(58424)))));
	},
	"./listProcessingUtils": () => {
		return Promise.all([__webpack_require__.e(156), __webpack_require__.e(56)]).then(() => (() => ((__webpack_require__(18056)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});